import { Grid, Box, Card, useTheme } from '@material-ui/core'
import React, { useRef, useState, useContext } from 'react'
import { components } from 'cng-web-lib'
import Stepper from '../../../components/aciacehighway/Stepper'
import PermitToTransferEditForm from './PermitToTransferEditPage'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import { useParams } from 'react-router-dom'
import ResponseMessage from './response/ResponseMessage'
import { ACEOceanTranslationContext } from '../contexts/ACEOceanTranslationContext'

const {
  form: { CngAddForm }
} = components

function EditPage({ history, loading, location, showNotification, onSetLoading }) {

  const { id } = useParams()

  const { state } = location

  const permitToTransferData = useRef(state?.permitToTransferData || null)
  const [permitToTransferStatus, setPermitToTransferStatus] = useState(null)
  const [step, setStep] = useState((state?.step ? state.step : 1) - 1)
  const [completed, setCompleted] = useState({})
  const [stepIconColor, setStepIconColor] = useState({})
  const theme = useTheme()

  function renderContent(step) {
    switch (step) {
      case 0:
        return (
          <PermitToTransferEditForm
            id={id}
            permitToTransferData={permitToTransferData}
            onChangeStep={(step) => setStep(step)}
            onSetPermitToTransferStatus={setPermitToTransferStatus}
            history={history}
            showNotification={showNotification}
            onSetLoading={onSetLoading}
            step={step}
          />)
      case 1:
        return (
          <ResponseMessage
            showNotification={showNotification}
            id={id}
            isViewOnly={true}
          />
        )
    }
  }

  return (
    <>
      <Card>
        <Stepper
          steps={!permitToTransferStatus || permitToTransferStatus === 'DR' ? ["Permit to Transfer"] : ["Permit to Transfer", "View Logs and History"]}
          activeStep={step}
          completed={completed}
          onSetActiveStep={(step) => setStep(step)}
          stepIconColor={stepIconColor}
        />
        <Box
          padding={2}
          style={{ backgroundColor: theme.palette.background.sectionOddBg }}
        >
          {renderContent(step)}
        </Box>
      </Card>
    </>
  )

}

export default withFormState(EditPage)
